import { render, staticRenderFns } from "./MessageCategoriesFilter.vue?vue&type=template&id=e2fb32c6&"
import script from "./MessageCategoriesFilter.vue?vue&type=script&lang=ts&"
export * from "./MessageCategoriesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports